import {Component, Input, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Location, Place} from "@app/interfaces";
import * as Leaflet from "leaflet";
import {control} from "leaflet";
import GestureHandling from "leaflet-gesture-handling";
import {LeafletModule} from "@bluehalo/ngx-leaflet";
import {IonAccordion, IonAccordionGroup, IonItem} from "@ionic/angular/standalone";

@Component({
  selector: 'app-map-single-location',
  imports: [CommonModule, LeafletModule, IonItem, IonAccordion, IonAccordionGroup],
  templateUrl: './map-single-location.component.html',
  styleUrl: './map-single-location.component.scss'
})
export class MapSingleLocationComponent implements OnInit {

  @Input() public place: Place | undefined;
  @Input() public location: Location | undefined;
  @Input() public title: string | undefined;

  public options: Leaflet.MapOptions = {};

  protected hasMapLocation: boolean = false;
  protected map: Leaflet.Map | undefined;

  constructor() {
    console.log(`${this.constructor.name}.constructor`);
  }

  ngOnInit(): void {
    console.log(`${this.constructor.name}.ngOnInit`);
    if (!this.location) {
      return;
    }

    if (this.location.lat && this.location.lng) {
      Leaflet.Map.addInitHook("addHandler", "gestureHandling", GestureHandling);

      console.log(`${this.constructor.name}.ngOnInit location`, this.location);
      this.hasMapLocation = true;
      this.options = {
        layers: this.getLayers(),
        zoom: 15,
        center: new Leaflet.LatLng(this.location.lat, this.location.lng),
        attributionControl: false,
      }

      // @ts-ignore
      this.options['gestureHandling'] = true;
    }
  }

  getLayers = (): Leaflet.Layer[] => {
    return [
      new Leaflet.TileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; OpenStreetMap contributors',
      } as Leaflet.TileLayerOptions),
      ...this.getMarker(),
    ] as Leaflet.Layer[];
  };

  getMarker = (): Leaflet.Marker[] => {
    let color = 'black';
    if (this.place?.type === 'association') {
      color = 'green';
    }
    if (this.place?.type === 'company') {
      color = 'blue';
    }
    if (this.place?.type === 'bus_stop') {
      color = 'orange';
    }
    if (this.place?.type === 'playground') {
      color = 'yellow';
    }
    if (this.place?.type === 'mailbox') {
      color = 'grey';
    }
    if (this.place?.type === 'pharmacy' || this.place?.type === 'physician') {
      color = 'red';
    }

    return this.location && this.location.lat && this.location.lng ? [
      new Leaflet.Marker(new Leaflet.LatLng(this.location.lat, this.location?.lng), {
        icon: new Leaflet.Icon({
          iconSize: [25, 41],
          iconAnchor: [12, 41],
          popupAnchor: [1, -34],
          shadowSize: [41, 41],
          iconUrl: `assets/map/marker-icon-2x-${color}.png`,
          shadowUrl: 'assets/map/marker-shadow.png',
        }),
        title: this.title
      } as Leaflet.MarkerOptions),
    ] as Leaflet.Marker[] : [] as Leaflet.Marker[];
  };

  onMapReady(map: Leaflet.Map) {
    console.log(`${this.constructor.name}.onMapReady`,);
    this.map = map;
    this.map.addControl(
      control.attribution({
        position: 'bottomright',
        prefix: 'Leaflet'
      })
    );
  }

  updateMap() {
    setTimeout(() => {
      this.map?.invalidateSize();
      window.scrollTo(0, 0);
    }, 50);
  }
}
